var _rect, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "",
    fillOpacity: 1,
    fill: "#a8a7a5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    fill: "#a8a7a5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0c-74.439,0-135,60.561-135,135s60.561,135,135,135s135-60.561,135-135S330.439,0,256,0z",
    id: "svg_3",
    fill: "#a8a7a5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_4",
    className: "selected",
    fillOpacity: 1,
    fill: "#a8a7a5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_5",
    fill: "#a8a7a5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.966,358.195C387.006,320.667,338.009,300,286,300h-60c-52.008,0-101.006,20.667-137.966,58.195    C51.255,395.539,31,444.833,31,497c0,8.284,6.716,15,15,15h420c8.284,0,15-6.716,15-15    C481,444.833,460.745,395.539,423.966,358.195z",
    id: "svg_6",
    fill: "#a8a7a5"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "svg_20"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "svg_21"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFill);
export default __webpack_public_path__ + "static/media/person-fill.d66e2dcbb812e1b7add63fe6925e15af.svg";
export { ForwardRef as ReactComponent };